import ReactGA from "react-ga4";
import { isWhiteLabel } from "utils/whiteLabel";

let isInitialized = false;

export const initGA = () => {
  if (typeof window === 'undefined') return;
  if (isWhiteLabel()) return;
  
  const isDevelopment = import.meta.env.DEV || import.meta.env.VITE_ENV === 'development';
  
  // if (isDevelopment) {
  //   console.log('GA4 skipped in development');
  //   return;
  // }

  if (!isInitialized) {
    ReactGA.initialize('G-JECQEBCGSB');
    isInitialized = true;
    console.log('GA4 initialized');
  }
};

export const trackPageView = (path) => {
  if (!isInitialized || isWhiteLabel()) return;
  
  ReactGA.send({ 
    hitType: "pageview", 
    page: path 
  });
};

let isMetaPixelInitialized = false;

export const initMetaPixel = (pixelId) => {
  if (typeof window === 'undefined') return;
  if (isWhiteLabel()) return;
  
  if (window.fbq && window.fbq.loaded) {
    console.log('Meta Pixel already initialized in HTML');
    isMetaPixelInitialized = true;
    return;
  }

  if (isMetaPixelInitialized) {
    console.log('Meta Pixel already initialized');
    return;
  }

  const isDevelopment = import.meta.env.DEV || import.meta.env.VITE_ENV === 'development';
  
  // if (isDevelopment) {
  //   console.log('Meta Pixel skipped in development');
  //   return;
  // }

  if (isMetaPixelInitialized) {
    console.log('Meta Pixel already initialized');
    return;
  }

  !function(f,b,e,v,n,t,s) {
    if(f.fbq) return;
    n=f.fbq=function(){
      n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments)
    };
    if(!f._fbq) f._fbq=n;
    n.push=n;
    n.loaded=!0;
    n.version='2.0';
    n.queue=[];
    t=b.createElement(e);
    t.async=!0;
    t.src=v;
    s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)
  }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
  
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');

  isMetaPixelInitialized = true;
  console.log('Meta Pixel initialized');
};

export const trackMetaPageView = () => {
  if (!isMetaPixelInitialized || !window.fbq || isWhiteLabel()) return;
  
  window.fbq('track', 'PageView');
  console.log('Meta Pixel: PageView tracked');
};

export const trackMetaEvent = (eventName, parameters = {}) => {
  if (isWhiteLabel()) return;
  // if (!isMetaPixelInitialized || !window.fbq) return;
  
  window.fbq('track', eventName, parameters);
  console.log('Meta Pixel Event:', eventName, parameters);
};

let isTikTokInitialized = false;

export const initTikTok = (pixelId) => {
  if (typeof window === 'undefined') return;
  if (isWhiteLabel()) return;
  
  if (window.ttq && window.ttq._i) {
    console.log('TikTok Pixel already initialized in HTML');
    isTikTokInitialized = true;
    return;
  }

  if (isTikTokInitialized) {
    console.log('TikTok Pixel already initialized');
    return;
  }

  const isDevelopment = import.meta.env.DEV || import.meta.env.VITE_ENV === 'development';
  
  // if (isDevelopment) {
  //   console.log('TikTok Pixel skipped in development');
  //   return;
  // }

  if (isTikTokInitialized) {
    console.log('TikTok Pixel already initialized');
    return;
  }

  !function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = w[t] = w[t] || [];
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
    ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
      }
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
      for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
      return e
    };
    ttq.load = function (e, n) {
      var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
      var o = document.createElement("script");
      o.type = "text/javascript", o.async = !0, o.src = i + "?sdkid=" + e + "&lib=" + t;
      var a = document.getElementsByTagName("script")[0];
      a.parentNode.insertBefore(o, a)
    };

    ttq.load(pixelId);
    ttq.page();
  }(window, document, 'ttq');

  isTikTokInitialized = true;
  console.log('TikTok Pixel initialized');
};

export const trackTikTokPageView = () => {
  if (!isTikTokInitialized || !window.ttq || isWhiteLabel()) return;
  
  window.ttq.page();
  console.log('TikTok: Page view tracked');
};

export const trackTikTokEvent = (eventName, properties = {}) => {
  if (isWhiteLabel()) return;
  // if (!isTikTokInitialized || !window.ttq) return;
  
  window.ttq.track(eventName, properties);
  console.log('TikTok Event:', eventName, properties);
};